import React from "react";

export default function About() {
  return (
    <section
      id="aboutUs"
      className="mx-auto"
      style={{
        maxWidth: "1000px",
        backgroundColor: "#e6e6e6",
        // borderRadius: "12px",
        padding: "2rem",
      }}
    >
      {/* Main heading */}
      <h2 className="fw-bold mb-4">About Us</h2>

      {/* History */}
      <div className="mb-5">
        <h5 className="fw-semibold mb-3">History</h5>
        <p style={{ textAlign: "justify", lineHeight: 1.6 }}>
          The Programmers, Developers Facebook group was founded in 2012 by John
          Carlo and his high school friends as most of them pursued IT-related
          courses when they entered college. The group was created as a space to
          share knowledge, ask questions, and learn from one another, inspired
          by John Carlo’s belief: “HINDI LAHAT NG ALAM MO ALAM KO, AT ALAM KO
          ALAM MO.” During that time, access to knowledge and resources was
          limited, and while many questions were being posted, few were being
          answered. This sparked an idea—why not invite students from other
          schools and universities to join the group? From that moment, the
          community grew exponentially, eventually becoming the largest Filipino
          IT community on Facebook.
        </p>
        <p style={{ textAlign: "justify", lineHeight: 1.6 }}>
          Today, PD remains committed in its mission to empower Filipino
          programmers and developers, fostering collaboration, innovation, and
          career growth, and playing an active role in driving the advancement
          of the Philippine tech industry.
        </p>
      </div>

      {/* Mission */}
      <div className="mb-5">
        <h5 className="fw-semibold mb-3">Mission</h5>
        <p style={{ textAlign: "justify", lineHeight: 1.6 }}>
          Our mission is to create a community where diverse experiences,
          skills, and insights are shared and valued. Empowering each member to
          grow by exchanging knowledge and learning, recognizing that we all
          have something unique to offer and can learn from one another.
        </p>
      </div>

      {/* Vision */}
      <div>
        <h5 className="fw-semibold mb-3">Vision</h5>
        <p style={{ textAlign: "justify", lineHeight: 1.6 }}>
          Our vision is to be the leading community for programmers, developers
          and IT professionals in the Philippines, where everyone can learn,
          grow, and contribute to advancing the tech industry..
        </p>
      </div>
    </section>
  );
}
